import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },

    {
        path: '/preview-home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },


    {
        path: '/viewpoints',
        name: 'viewpoints-page',
        props: true,
        component: () => import(/* webpackChunkName: "viewpoints" */ '../views/Viewpoints.vue')
    },

    {
        path: '/viewpoints/:slug',
        name: 'viewpoints-category',
        props: true,
        component: () => import(/* webpackChunkName: "viewpoints" */ '../views/Viewpoints.vue')
    },

    {
        path: '/preview-viewpoint',
        name: 'single-viewpoints',
        props: true,
        component: () => import(/* webpackChunkName: "single-viewpoints" */ '../views/Viewpoint.vue')
    },

    {
        path: '/viewpoint/:slug',
        name: 'single-viewpoints',
        props: true,
        component: () => import(/* webpackChunkName: "single-viewpoints" */ '../views/Viewpoint.vue')
    },

    {
        path: '/case-studies',
        name: 'cases-page',
        props: true,
        component: () => import(/* webpackChunkName: "cases" */ '../views/CaseStudies.vue')
    },

    {
        path: '/preview-case',
        name: 'single-case',
        props: true,
        component: () => import(/* webpackChunkName: "single-case" */ '../views/Case.vue')
    },

    {
        path: '/casestudy/:slug',
        name: 'single-case',
        props: true,
        component: () => import(/* webpackChunkName: "single-case" */ '../views/Case.vue')
    },

    {
        path: '/news',
        name: 'news',
        props: true,
        component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
    },

    {
        path: '/preview-news',
        name: 'single-news',
        props: true,
        component: () => import(/* webpackChunkName: "single-news" */ '../views/New.vue')
    },

    {
        path: '/news/:slug',
        name: 'single-news',
        props: true,
        component: () => import(/* webpackChunkName: "single-news" */ '../views/New.vue')
    },


    {
        path: '/join-us',
        name: 'jobs',
        props: true,
        component: () => import(/* webpackChunkName: "jobs" */ '../views/Jobs.vue')
    },

    {
        path: '/preview-jobs',
        name: 'single-job',
        props: true,
        component: () => import(/* webpackChunkName: "single-job" */ '../views/Job.vue')
    },

    {
        path: '/job/:slug',
        name: 'single-job',
        props: true,
        component: () => import(/* webpackChunkName: "single-job" */ '../views/Job.vue')
    },

    {
        path: '/about-us',
        name: 'team',
        props: true,
        component: () => import(/* webpackChunkName: "team" */ '../views/Team.vue')
    },

    {
        path: '/approach',
        name: 'approach',
        props: true,
        component: () => import(/* webpackChunkName: "approach" */ '../views/Approach.vue')
    },

    {
        path: '/team/:slug',
        name: 'single-team',
        props: true,
        component: () => import(/* webpackChunkName: "team" */ '../views/Team.vue')
    },

    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        props: true,
        component: () => import(/* webpackChunkName: "privacy-policy" */ '../views/PrivacyPolicy.vue')
    },


    {
        path: '/search',
        name: 'search',
        props: true,
        component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
    },


    {
        path: '/services',
        name: 'Services',
        props: true,
        component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue')
    },

    {
        path: '/preview-services',
        name: 'preview-services',
        props: true,
        component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue')
    },

    {
        path: '/preview-approach',
        name: 'preview-approach',
        props: true,
        component: () => import(/* webpackChunkName: "approach" */ '../views/Approach.vue')
    },

    {
        path: '/preview-case-studies',
        name: 'preview-cases-page',
        props: true,
        component: () => import(/* webpackChunkName: "cases" */ '../views/CaseStudies.vue')
    },

    {
        path: '/preview-page',
        name: 'page',
        props: true,
        component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
    },

    {
        path: '/:page_slug',
        name: 'page',
        meta: 'page',
        props: true,
        component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
    },

    // {
    //     path: '/:page_slug/:sub_page_slug',
    //     name: 'sub-page',
    //     meta: 'page',
    //     props: true,
    //     component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
    // },

    {
        path: '*',
        name: 'not-found',
        component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
    },
]


let base_url = '/';
if (process.env.NODE_ENV === 'production') base_url = '/';

const router = new VueRouter({
    mode: 'history',
    base: base_url,
    routes
});



/**
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


// router.beforeEach((to, from, next) => {
//     console.log('beforeEach')
// })

// router.afterEach((to, from) => {
//     console.log('afterEach')
// })


export default router
